import { Component, Input } from '@angular/core';
import { Sbi } from '../../../../../models/sbi';

@Component({
  selector: 'app-generic-sbi-card',
  templateUrl: './generic-sbi-card.component.html',
  styleUrls: ['./generic-sbi-card.component.css']
})
export class GenericSbiCardComponent {
  @Input() sbi: Sbi;
  @Input() showSuggestion: boolean = true;
}
